export default 'marvel-prototype-resize-root';
